import { DialogRef } from '@angular/cdk/dialog';
import { booleanAttribute, Component, computed, input } from '@angular/core';

@Component({
  selector: 'topo-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  dialogRef = input.required<DialogRef>();
  title = input<string>();
  hideHeaderClose = input(false, { transform: booleanAttribute });
  showHeader = computed(() => !!this.title() || !this.hideHeaderClose());
  showHeaderBorder = input(false, { transform: booleanAttribute });
  showFooterBorder = input(false, { transform: booleanAttribute });
}
